export const getCounselorTypes = {
  REQUEST: 'GET_COUNSELOR_REQUEST',
  SUCCESS: 'GET_COUNSELOR_SUCCESS',
  FAILED: 'GET_COUNSELOR_FAILED',
};
